import { AlertCircle, LogIn, ShieldCheck } from 'lucide-react'
import { Merk } from '../onderdelen/ui'

/* ===========================================================================
 *  Voor wie nog niet binnen is
 *
 *  Er is hier geen eigen wachtwoord: je logt in bij het dashboard en komt
 *  terug (zie worker/inloggen.ts). Eén knop, en als het mislukte een zin
 *  die zegt waarom. Overgenomen uit Exact.
 * =========================================================================== */

const UITLEG: Record<string, string> = {
  'geen-toegang':
    'Je bent ingelogd, maar TW10 staat voor jouw account niet aan. Hoort dat wel zo te zijn, '
    + 'vraag het dan aan iemand van management: die kan het recht "TW10 (facturen op de telefoon)" '
    + 'in het dashboard aan je geven.',
  'niet-na-te-kijken':
    'Je toegang kon even niet worden nagekeken. Dat ligt niet aan jou; probeer het over een minuut opnieuw.',
  'geen-briefje': 'De link waarmee je hier kwam was niet compleet. Probeer het opnieuw vanaf het dashboard.',
  'briefje-klopt-niet':
    'Het toegangsbewijs klopte niet. Dat gebeurt als een link is aangepast of doorgestuurd. '
    + 'Meld je hieronder gewoon opnieuw aan.',
  'briefje-verlopen': 'Het toegangsbewijs was verlopen; die is maar een minuut geldig. Meld je hieronder opnieuw aan.',
  'briefje-al-gebruikt': 'Dit toegangsbewijs was al gebruikt; hij werkt één keer. Meld je hieronder gewoon opnieuw aan.',
  'reis-verlopen': 'Het duurde te lang tussen het beginnen en het inloggen. Probeer het nog een keer.',
  'reis-klopt-niet': 'Er ging iets mis bij het terugkomen van het dashboard. Begin opnieuw; blijft het gebeuren, meld het dan.',
  'geen-code': 'Het dashboard stuurde geen antwoord mee. Probeer het opnieuw.',
  'dashboard-onbereikbaar': 'Het dashboard was even niet bereikbaar. Probeer het over een minuut nog eens.',
  'inloggen-mislukt':
    'Het dashboard wilde je niet doorlaten. Kun je daar wel inloggen? Zo ja, meld dit dan; dan zit het aan onze kant.',
  'niet-ingericht': 'TW10 is nog niet helemaal ingesteld. Dit is niets wat jij kunt oplossen; geef het door.',
}

export default function Poort({ fout }: { fout: string | null }) {
  const tekst = fout ? (UITLEG[fout] ?? 'Het inloggen is niet gelukt.') : null
  const heen = location.pathname !== '/' ? location.pathname + location.search : ''

  return (
    <div className="start poort">
      <div className="start-band"><Merk /></div>
      <section className="start-groet">
        <h1>Facturen op je telefoon</h1>
        <p>
          De to-do, tekenen, zoeken en scannen, met je account van het dashboard.
          Je wachtwoord komt hier niet langs.
        </p>
      </section>

      {tekst && (
        <div className="foutvak poort-fout" role="alert">
          <AlertCircle size={18} aria-hidden="true" />
          <div>{tekst}</div>
        </div>
      )}

      <div className="poort-knoppen">
        <a className="knop breed blauw groot" href={`/aanmelden${heen ? `?heen=${encodeURIComponent(heen)}` : ''}`}>
          <LogIn size={20} /> Inloggen via het dashboard
        </a>
        <p className="klein zacht poort-voet"><ShieldCheck size={14} /> Truckwash 1 Group</p>
      </div>
    </div>
  )
}
